import { BaseURL } from "../../config/axios";
import { Link } from "react-router-dom";

export default function ArtistsSection({ data = [] }) {

  return (
    <section className="container flex flex-col w-full items-center my-12 gap-6">
      <div dir="rtl" className="flex text-center flex-col gap-6">
        <h3 className="title">معروفترین هنرمندان</h3>
      </div>

      <div className="grid md:grid-cols-5 grid-cols-2 gap-6 p-6">
        {data.map((item, index) => (
          <GalleryItem key={index} {...item} />
        ))}
      </div>

      <Link
        to="/artists"
        className="bg-gray-200 rounded-lg px-4 py-2  text-md"
      >
        همه هنرمندان
      </Link>
    </section>
  );
}

function GalleryItem({ id, slug, title, images }) {
  return (
    <Link to={"artists/" + slug} className="flex flex-col shadow rounded">
      <div className="centerOfParent w-full h-auto max-h-48 rounded overflow-hidden grow">
        <img placeholder='blur' blurDataURL='/images/placeholder-1.png'
          width={100} height={100} className="w-full h-full object-contain" src={BaseURL + images[0]?.path} alt={title} />
      </div>
      <span className="text-center p-3">{title}</span>
    </Link>
  );
}